import { ProductTypes } from './types';

export const getDGCoverIdByProductType = (productType: ProductTypes) => {
  if (productType === 'vida_flex') {
    return process.env.REACT_APP_environment === 'master'
      ? 7986126469
      : 40529107360;
  }
};

export const getDGCoverIdByProductIdAndCoverType = (
  productId: number,
  coverType: string
) => {
  if (productId === 1181397586) {
    if (coverType === 'PACK30') {
      return 7014310110;
    }

    if (coverType === 'PACK20') {
      return 7328456070;
    }

    if (coverType === 'PACK10') {
      return 7328456071;
    }

    if (coverType === 'PACK6') {
      return 7328456068;
    }
  }
  if (productId === 40529084990) {
    if (coverType === 'PACK30') {
      return 40529107360;
    }

    if (coverType === 'PACK20') {
      return 7328456070;
    }

    if (coverType === 'PACK10') {
      return 7328456071;
    }

    if (coverType === 'PACK6') {
      return 7328456068;
    }
  }

  if (productId === 7986106960) {
    if (coverType === 'PACK30') {
      return 7986126469;
    }

    if (coverType === 'PACK20') {
      return 7328456070;
    }

    if (coverType === 'PACK10') {
      return 7328456071;
    }

    if (coverType === 'PACK6') {
      return 7328456068;
    }
  }
};
